import Box from '@material-ui/core/Box';
import useLayout from '../../styles/layout'
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { reserveRoutes } from '../../router/routeConfig'
import { useLocation } from 'react-router-dom'
import _ from 'lodash'
import { SelectInput } from '../../components/common/components'
import { setResultValue } from '../../actions'
import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux'
import Swal from 'sweetalert2'
import { Helmet } from "react-helmet";
import { useHistory } from "react-router-dom";
import ProgressBar from '../../components/ProgressBar'
import { weeks } from '../../utils/utils'
import '../../styles/print.css'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

const genderName = {
    "M":"男",
    "F": "女"
}

export default function Reserve() {

    const layoutClasses = useLayout()

    const location = useLocation();

    const idx = _.findIndex(reserveRoutes, (o) => o.path === location.pathname)

    const result = (useSelector(state => state.getIn(["result", "result"]))).toJS()

    const dispatch = useDispatch()

    let history = useHistory();

    const handleNextClick = () => {

    }

    useEffect(() => {
        if (_.isEmpty(result)) {
            // Swal.fire("無預約資訊", "", "info")
            history.push('/')
        }
        return () => {
            dispatch(setResultValue({ value: [] }))
        }
    }, [])

    return <Box className={layoutClasses.page}>
        <Helmet>
            <title>{reserveRoutes[idx].name}</title>
        </Helmet>
        <ProgressBar />
        <Paper
            elevation={3}
            square
            className={layoutClasses.paper}
        >
            <Typography variant="subtitle1" gutterBottom align="center">
                {reserveRoutes[idx].name}
            </Typography>
            {_.map(result, (item, key) => {
                return <Box key={item.TICKET_NO} mt={5}>
                    <Typography variant="body1" gutterBottom>
                        預約項目：{item.CODE_NAME}
                    </Typography>
                    <Typography variant="body1" gutterBottom style={{ color: 'red' }}>
                        預約日期：{item.SCHD_DATE_STR}({weeks[item.DAYS_STR]})
                    </Typography>
                    <Typography variant="body1" gutterBottom style={{ color: 'red' }}>
                        開診時間：{item.SCHD_TIME_STR}
                    </Typography>
                    <Typography variant="body1" gutterBottom style={{ color: 'red' }}>
                        最後報到時間：{item.DEADLINE_ARRIVAL_TIME_STR}
                    </Typography>
                    <Typography variant="body1" gutterBottom  style={{color:'red'}}>
                        報到地點：{item.AREA_NAME}
                    </Typography>
                    <Typography variant="body1" gutterBottom style={{ color: 'red', whiteSpace: "pre-line" }}>
                        注意事項：{item.NOTES}
                    </Typography>

                    {/* <Typography variant="body1" gutterBottom>
                        預約代號：{item.TICKET_NO}
                    </Typography> */}
                    <Typography variant="body1" gutterBottom>
                        身分證字號：{item.PAT_IDNO}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        性別：{item.SEX?genderName[item.SEX]:""}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        聯絡電話：{item.TEL_MOBILE}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        生日：{item.BIRTHDAY}
                    </Typography>
                    <Typography variant="body1" gutterBottom>
                        電子郵件：{item.EMAIL}
                    </Typography>


                    <hr />
                </Box>
            })}

            <Typography variant="body1" gutterBottom style={{ color: "red" }}>
                {/* {result.VACC_LST_TXT} */}
                {/* *接種當日，請務必攜帶執業登記證或工作證及有效工作證明 */}
            </Typography>
            <Typography variant="body1" gutterBottom style={{ lineHeight: "2", padding: "10px 0" }}>
                報名注意需知：<br />
                【報名方式】當天務必攜帶健保卡及身分證，現場查驗符合資格後進行報名。<br />
                【成人預防保健(報名)】如欲當日即進行抽血，請於檢查前8小時保持空腹。<br />
                【成人預防保健(回診)】<br />
                *	成人預防保健二階回診含醫師理學檢查、血液及尿液檢查報告結果說明，未提供五癌篩檢報告諮詢。<br />
                *	若欲申請成人健檢紙本報告，請至 B1中央櫃台申請（須自費）。<br />

                【肺癌篩檢】符合家族史的民眾報名請攜帶肺癌家人的姓名、身分證號碼、出生年月日等資料，當日報名完成後，將再安排檢查時間。<br />
                【子宮頸癌篩檢】請避開生理期間。<br />




            </Typography>
            {/* <div>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell colSpan={2} align="center">服務時間</TableCell>
                            <TableCell align="center">報名地點</TableCell>
                            <TableCell align="center">肺癌</TableCell>
                            <TableCell align="center">乳癌</TableCell>
                            <TableCell align="center">大腸癌</TableCell>
                            <TableCell align="center">口腔癌</TableCell>
                            <TableCell align="center">子宮頸癌</TableCell>
                            <TableCell align="center">成人預防保健</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell rowSpan={3} align="center">周一至週五</TableCell>
                            <TableCell align="center">0900-1600</TableCell>
                            <TableCell align="center">B1中央櫃台</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell align="center">V</TableCell>
                            <TableCell align="center">V</TableCell>
                            <TableCell rowSpan={3} align="center">抹片檢查，請掛本院婦科門診</TableCell>
                            <TableCell align="center">V</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="center">0900-1200</TableCell>
                            <TableCell align="center">B1婦女門診</TableCell>
                            <TableCell></TableCell>
                            <TableCell align="center">V</TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="center">1300-1600</TableCell>
                            <TableCell align="center">3F大健康中心</TableCell>
                            <TableCell align="center">V</TableCell>
                            <TableCell align="center">V</TableCell>
                            <TableCell align="center">V</TableCell>
                            <TableCell align="center">V</TableCell>
                            <TableCell align="center">V</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </div> */}
            <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                <Button
                    variant="contained"
                    color="secondary"
                    onClick={() => { window.print() }}
                    style={{ marginTop: "20px" }}
                >
                    儲存成PDF
                </Button>
            </div>

        </Paper>


        <div>
            <Button
                variant="contained"
                // color="secondary"
                style={{ margin: "30px" }}
                onClick={() => { window.location.href = "./first_step" }}
            >
                回　首　頁
            </Button>
            <Button
                variant="contained"
                color="primary"
                style={{ margin: "30px" }}
                onClick={() => { history.push('/search') }}
            >
                至查詢頁面
            </Button>
        </div>
    </Box>
}